import { render, staticRenderFns } from "./DecisionForChrist.vue?vue&type=template&id=24c13004&"
import script from "./DecisionForChrist.vue?vue&type=script&lang=js&"
export * from "./DecisionForChrist.vue?vue&type=script&lang=js&"
import style0 from "./DecisionForChrist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports